module.exports = __webpack_public_path__ + "img/cloth_g3_sleeve-07.c0851f92.svg";